import { render, staticRenderFns } from "./secDownload.vue?vue&type=template&id=23220f81&scoped=true&"
import script from "./secDownload.vue?vue&type=script&lang=js&"
export * from "./secDownload.vue?vue&type=script&lang=js&"
import style0 from "./secDownload.vue?vue&type=style&index=0&id=23220f81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23220f81",
  null
  
)

export default component.exports